import { render, staticRenderFns } from "./SwiperNavigationButton.vue?vue&type=template&id=6b811f2c&"
import script from "./SwiperNavigationButton.vue?vue&type=script&lang=js&"
export * from "./SwiperNavigationButton.vue?vue&type=script&lang=js&"
import style0 from "./SwiperNavigationButton.vue?vue&type=style&index=0&id=6b811f2c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports